/**
 * The footprints a TCR navigates with, one per nav2 params file the robot can launch. Which one
 * a robot uses depends on its localization backend and profile (tcr robot_platform launch):
 *
 *   AMCL      nav_amcl.launch.py → nav2_params.yaml, or nav2_params_with_attachment.yaml when the
 *             profile sets add_attachment (that file has no RouteNetwork planner)
 *   FAST-LIO  tcr_nav2 nav_fastlio.launch.py → nav2_params_fastlio.yaml
 *
 * The robot does not report its footprint yet, so the editor lets the technician pick the one
 * to check against. Validation uses DEFAULT_FOOTPRINT_PROFILE: of the two plain bases it is the
 * wider, so a pose clear for it is clear for FAST-LIO too.
 */
import { z } from "zod";
import { TCR_FOOTPRINT } from "./footprint.js";
export const FootprintProfileId = z.enum(["tcr_amcl", "tcr_fastlio", "tcr_attachment"]);
/** Counter-clockwise box in base_link from its front, rear and half width. */
function box(front, rear, halfWidth) {
    return [
        { x: front, y: -halfWidth },
        { x: front, y: halfWidth },
        { x: rear, y: halfWidth },
        { x: rear, y: -halfWidth },
    ];
}
export const FOOTPRINT_PROFILES = {
    tcr_amcl: { label: "TCR (AMCL), 1.10 × 0.47 m", footprint: TCR_FOOTPRINT, source: "robot_config/tcr/config/navigation/nav2_params.yaml" },
    tcr_fastlio: { label: "TCR (FAST-LIO), 1.10 × 0.42 m", footprint: box(0.69, -0.41, 0.21), source: "robot_config/tcr/config/navigation/nav2_params_fastlio.yaml" },
    tcr_attachment: { label: "TCR with attachment, 1.11 × 0.43 m", footprint: box(0.24, -0.87, 0.215), source: "robot_config/tcr/config/navigation/nav2_params_with_attachment.yaml" },
};
export const DEFAULT_FOOTPRINT_PROFILE = "tcr_amcl";
//# sourceMappingURL=robot-footprints.js.map